import { useEffect, useRef, useState } from 'react';
import { useForm } from "react-hook-form";

const SupplierList = () => {
    const [showData, setData] = useState([]);
  
    const [queryValue, setQueryValue] = useState('');
    let [selectedItem, setSelectedItem] = useState(0);
    const [backup, setBackup] = useState([]);
    const { register, handleSubmit } = useForm();
    const selectAll = useRef(null);
  
    const data = [
      {
        id: 1,
        supplierName: 'All Time',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
      {
        id: 2,
        supplierName: 'Delux',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
      {
        id: 3,
        supplierName: 'Dell',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
      {
        id: 4,
        supplierName: 'Intel',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
      {
        id: 5,
        supplierName: 'Vision',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
      {
        id: 6,
        supplierName: 'RFL',
        phone: '018738646738',
        officeLocation: 'Gulshan Dhaka 4/6',
        totalSupplyProduct: 5000,
      },
    ]
    
    useEffect(() => {
      // fetch("https://jsonplaceholder.typicode.com/users")
      // .then((res) => res.json())
      // .then((data) => setData(data));
  
      setData(data);
      setBackup(data);
    }, []);
    
    const deleteHandler = ({categoryIds}) => {
      console.log(categoryIds);
      const newCategory = backup.filter(item => !categoryIds.includes(item?.id?.toString() || ''));
      setQueryValue('');
      setData(newCategory);
      selectAll.current.indeterminate = false;
      selectAll.current.checked = false;
      setSelectedItem(0);
    }
    const checkUncheckHandler = (e) => {
        const { id, checked } = e.target;
    
        if(id === 'allSelect'){
            let i = 0;
            let tempData = showData.filter((user)=> user.supplierName.toLowerCase().includes(queryValue)).map(item => {
                if(checked){
                    setSelectedItem(++i);
                }else{
                    setSelectedItem(0);
                }
                return {...item, isChecked: checked}
            });
            const restData = backup.filter((user)=> !user.supplierName.toLowerCase().includes(queryValue));
            setData([...tempData, ...restData]);
        }else{
            if(checked){
                selectAll.current.checked = true;
                selectAll.current.indeterminate = true;
                setSelectedItem((prev) => {
                    if(prev === (showData.length - 1)){
                        selectAll.current.indeterminate = false;
                        selectAll.current.checked = true;
                    };
                    return prev+1;
                });
            }else{
                setSelectedItem((prev) => {
                    if(prev > 1) selectAll.current.indeterminate = true;
                    
                    if(prev === 1) selectAll.current.indeterminate = false;
                    if((prev-1) === 0) selectAll.current.checked = false;
                    
                    return prev-1;
                });
            };
            
            const tempCategory = showData.map(item => item.id === parseInt(id) ? {...item, isChecked: checked} : item);

            setData(tempCategory);
        }
      };
  
return (
    <div className='ms:container mx-auto px-5 mt-10'>
        <h1 className="text-xl font-semibold text-gray-700 mb-5">Supplier List</h1>

        {/* action bar */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center my-4 gap-y-4 sm:gap-y-0">
          <div>
            <div className="form-control sm:w-72">
              <label className="input-group input-group-sm">
                <span className="pl-2 pr-0 bg-transparent border-2 border-r-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                </span>
                <input type="text" onChange={(e) => setQueryValue(e.target.value)} placeholder="Search by supplier name" className="input input-bordered border-l-0 input-sm w-full" />
              </label>
            </div>
          </div>
            <>
                {
                    selectedItem > 0 &&
                    <div className="flex justify-between items-center pt-1 sm:pt-0 sm:gap-4">
                        <p className="text-sm">{selectedItem} selected</p>
                        <button type="submit" className="btn btn-sm btn-square bg-gray-100 border-gray-300 text-black hover:bg-gray-200 hover:border-gray-400" form="tableItemSelector">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                }
            </>
        </div>

        <form id="tableItemSelector" className="overflow-x-auto" onSubmit={handleSubmit(deleteHandler)}>
          <table className="table table-compact w-full">
            <thead>
              <tr>
                <th>
                  <label>
                    <input type="checkbox" id='allSelect' value={undefined} {...register("categoryIds")} onChange={checkUncheckHandler} className="checkbox" ref={selectAll} />
                  </label>
                </th>
                <th>Supplier Name</th>
                <th>Phone Number</th>
                <th>Office Location</th>
                <th>Total Supply</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
              showData.filter((user)=> user.supplierName.toLowerCase().includes(queryValue)).map((SingleData) => (
                <tr key={SingleData.id}>
                  <th>
                    <label>
                    <input type="checkbox" id={SingleData.id} value={SingleData.id} {...register("categoryIds")} checked={SingleData?.isChecked || false} onChange={checkUncheckHandler} className="checkbox" />
                    </label>
                  </th>
                  <td>{SingleData.supplierName}</td>
                  <td>{SingleData.phone}</td>
                  <td>{SingleData.officeLocation}</td>
                  <td>{SingleData.totalSupplyProduct}</td>
                  <td>
                    <label for="my-modal-3" className="btn btn-sm btn-square bg-gray-100 border-gray-300 text-black hover:bg-gray-200 hover:border-gray-400 modal-button">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </form>

        {/* Modal */}
        <input type="checkbox" id="my-modal-3" class="modal-toggle" />
        <div class="modal">
          <div class="modal-box relative">
            <label for="my-modal-3" class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
            <h3 class="sm:text-lg font-bold mb-4">Update Supplier List</h3>
            <form>
              <div class="form-control w-full">
                <label class="label text-sm font-medium">Supplier Name:</label>
                <input type="text" placeholder="Supplier name" class="input input-sm input-bordered w-full" />
              </div>
              <div class="form-control w-full">
                <label class="label text-sm font-medium">Phone Number:</label>
                <input type="text" placeholder="Phone number" class="input input-sm input-bordered w-full" />
              </div>
              <div class="form-control w-full">
                <label class="label text-sm font-medium">Office Location:</label>
                <input type="text" placeholder="Office location" class="input input-sm input-bordered w-full" />
              </div>
              <div class="form-control w-full">
                <label class="label text-sm font-medium">Total Supply:</label>
                <input type="text" placeholder="Total supply" class="input input-sm input-bordered w-full" />
              </div>
              <button className="btn btn-sm w-full mt-4">Update</button>
            </form>
          </div>
        </div>
      </div>
    );
};

export default SupplierList;